// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-06cc7e34] .slick-list{margin:0 -10px 0 -12px}[data-v-06cc7e34] .slick-list .slick-slide>div:first-child{height:470px !important}[data-v-06cc7e34] .slick-track{display:flex}[data-v-06cc7e34] .slick-arrow{display:none !important}.padding[data-v-06cc7e34]{padding:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
